import styled from 'styled-components';
import { Text } from '../../Text/Text';

export const SwitchStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;

export const StatusText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.textSecondarySubtleGrey80};
  padding-left: 4px;
`;
export const LabelText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  padding-right: 8px;
`;
